import React from "react"
import App from "./App"
import { createRoot } from "react-dom/client"
import "./index.scss"

const container = document.createElement("div")
document.body.appendChild(container)
const root = createRoot(container)
root.render(<App />)
